module.exports = {
  metadata: {
    title: "kodado",
    description: "Website created with create-tpws-website",
    author: "https://turingpages.de",
    generator: "turingpages",
  },

  tpws: {
    environments: {
      development: {
        siteUrl: "http://localhost:9000",
      },
      staging: {
        siteUrl: "https://preview.staging.kodadodev.pulso-media.de",
      },
      production: {
        siteUrl: "https://kodado.dev",
      },
    },
    defaultLocale: "en",
    dynamicTemplate: "./src/templates/dynamic-template.js",
    subfont: false,
    allowHtml: false,
  },

  strapi: {
    environments: {
      development: {
        url: "http://localhost:3000",
        token:
          "0116e187698e88e39158192a22cc4a6634c41a39abf2c846986c225a340bb3ed37d907535a45942b9666ba7a6c80480090d02f4f3649aae0be0f026c021fc93736a18ca7b1b6d2b54da09e89e6cce64ab8f5c67d879b4caf512b1d262a7a1f9fad50ca00e2e0498ee08c24eecfc19196a5d87d1651a4156ba372682ca855d354",
      },
      staging: {
        url: "https://staging.kodadodev.pulso-media.de",
        token:
          "7aeb3f6e7cb60e0513f2ad1c93b42db4fae3dce86581f3957f140b89703cd82989188a381c15db04a42525057ce39574bca65e9f9223c6389c9fba79e2431d71480b30038d6c9ff25a8673332ffb642e0e970ef39656966d90acb3297595482b3705251ccf367d8a7c0860aad97587ea09ee28b2a9d1bc196934b5d24614aaa2",
      },
      production: {
        url: "https://kodadodev.pulso-media.de",
        token:
          "0116e187698e88e39158192a22cc4a6634c41a39abf2c846986c225a340bb3ed37d907535a45942b9666ba7a6c80480090d02f4f3649aae0be0f026c021fc93736a18ca7b1b6d2b54da09e89e6cce64ab8f5c67d879b4caf512b1d262a7a1f9fad50ca00e2e0498ee08c24eecfc19196a5d87d1651a4156ba372682ca855d354",
      },
    },
    collectionTypes: [],
    singleTypes: [],
  },
  /* shopify: {
    url: "mystore.myshopify.com",
    password: "<<shppa_pwd>>",
    token: "<<token>>",
  }, */
};
